
import Account from '../Resources/script.js' //scripts

export default {
    name: 'Settings',
    mixins: [Account],
    data () {
        return {
        }
    },

    components: {
        
    },
     
    methods: {

        backTo(){
            window.history.back(); 
        },
      
    },

    created: function(){
        this.loading = true;
        let self = this;
        setTimeout(function(){ self.getAppGroups(); }, 1000); //wait for 3sec 
    }
}


// WEBPACK FOOTER //
// ./src/pages/Account/Groups/script.js